import 'css-chunk:src/app/containers/Projects/ProjectsPage/Cell/OwnersCell.scss';export default {
  "OwnersCell": "_OwnersCell_37151_1"
};